import React from "react";
import "./NewsletterSubscribe.css";
import { FaPaperPlane } from "react-icons/fa";
import { Button, Container, Row, Col } from "react-bootstrap";

export default function NewsletterSubscribe() {
  return (
    <section className="newsletter-section">
      <Container>
        <Row className="align-items-center">
          <Col md={1} className="icon-col text-center mb-3 mb-md-0">
            <FaPaperPlane className="paper-plane" />
          </Col>
          <Col md={8} className="text-col text-center text-md-start">
            <h4 className="headline">Ready for the latest tech insights?</h4>
            <p className="subtext">
              Subscribe to my newsletter and stay updated on trends that shape our digital world.
            </p>
          </Col>
          <Col md={3} className="button-col text-center text-md-end">
            <Button variant="light" className="subscribe-button">
              SUBSCRIBE
            </Button>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
